export const SOFTLINE_FEATURE_MODAL = 'modals';
